import { useEffect } from "react"

export const Modal = ({ 
  isOpen, 
  onClose, 
  children, 
  title,
  size = "md"
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "unset"
    }
    
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [isOpen])

  if (!isOpen) return null

  const sizeStyles = {
    sm: { maxWidth: "24rem" },
    md: { maxWidth: "28rem" },
    lg: { maxWidth: "32rem" },
    xl: { maxWidth: "36rem" }
  }

  const overlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px"
  }

  const contentStyles = {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    width: "100%",
    maxHeight: "90vh",
    overflow: "auto",
    padding: "24px",
    ...sizeStyles[size]
  }

  const headerStyles = {
    marginBottom: "16px"
  }

  const titleStyles = {
    fontSize: "20px",
    fontWeight: "600",
    color: "#111827",
    margin: 0
  }

  return (
    <div 
      style={overlayStyles}
      onClick={onClose}
    >
      <div 
        style={contentStyles}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div style={headerStyles}>
            <h2 style={titleStyles}>{title}</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  )
}